'use strict';

var Signal = require('@getgo/signal');

var LogFormattingHelpers = require('./helpers/log_formatting_helpers');

function processLogCall(logger, level, args) {
    var data;
    var msg;
    var logEntry;

    var moduleName;
    var moduleContext;

    var root = logger.root;

    root.signals.onRawLog.dispatch({
        level: level,
        arguments: args,
        module: logger
    });

    // Grab data object if present
    data = LogFormattingHelpers.consumeDataObject(args);

    // Consider first arg as message if string
    if (args.length > 0 && typeof args[0] === 'string') {
        msg = args.shift();
        // Grab data object left after message string
        data = LogFormattingHelpers.consumeDataObject(args);
    }

    // No structured data, let's build it from the args if any
    // and attempt to log them as cleanly as possible
    if (!data && args.length > 0) {
        data = LogFormattingHelpers.consumeUnstructuredArgs(args);
    }

    // Let's build our log entry. The order in which properties are added is kept in server logs
    // args should be an empty array by now, re-add structured data for local targets
    logEntry = {};

    // First put logging context in the log entry. args don't need those
    logEntry.seqNum = root.seqNum++;
    logEntry.level = level;
    logEntry.timestamp = (new Date()).toJSON();

    // Then add module info if any
    // args get context data after moduleName and msg
    // log entry gets context data before them

    moduleName = logger.fullNodeName;

    // Put moduleName and msg in the args
    if (moduleName) args.push(moduleName);
    if (msg !== undefined) args.push(msg);

    // Add context data to args and log entry
    moduleContext = logger.getFullNodeContext(false);
    Object.keys(moduleContext).forEach(function forEachModuleContextProp(prop) {
        logEntry[prop] = moduleContext[prop];
        args.push(prop + '=', moduleContext[prop]);
    });

    // Put moduleName and msg in the log entry
    if (moduleName) logEntry.module = moduleName;
    if (msg !== undefined) logEntry.msg = msg;

    // Finally, make sure we have a user data object to work with then flatten it
    data = data || {};
    Object.keys(data).forEach(function forEachDataProp(prop) {
        LogFormattingHelpers.flattenDataProperty(logEntry, prop, data[prop]);
        args.push(prop + '=', data[prop]);
    });

    // Errors in targets "should" be handled by the targets themselves
    root.signals.onLineLog.dispatch({
        level: level,
        arguments: args
    });

    root.signals.onFormattedLog.dispatch({
        // Object for future extensibility
        entry: logEntry
    });
}

function tryLog(logger, level, args) {
    var fullNodeName;
    try {
        processLogCall(logger, level, args);
    } catch (error) {
        try {
            try {
                fullNodeName = logger.fullNodeName;
            } catch (ignoreError) {
              // Ignore a broken fullNodeName getter
            }

            logger.root.signals.onError.dispatch({
                source: 'message',
                type: 'error',
                detail: {
                    error: error,
                    module: fullNodeName
                }
            });
        } catch (nestedError) {
            setTimeout(function rethrowNestedError() {
                throw nestedError;
            }, 0);
        }
    }
}

function createLogFunction(level) {
    return function log() {
        var argslen = arguments.length;
        var args = new Array(argslen);
        var i;

        for (i = 0; i < argslen; ++i) {
            args[i] = arguments[i];
        }

        tryLog(this, level, args);
    };
}

function Logger() {
}

Logger.prototype.log = createLogFunction('log');
Logger.prototype.warn = createLogFunction('warn');
Logger.prototype.info = createLogFunction('info');
Logger.prototype.error = createLogFunction('error');
Logger.prototype.debug = createLogFunction('debug');

Logger.prototype.flush = function flush() {
    var root = this.root;
    if (root && root !== this) root.flush();
};

function getLoggerMethodOverrides() {
    return {
        setContext: function setContext(prop, value) {
            setContext._super.call(this, prop, value, LogFormattingHelpers.flattenDataProperty);
        }
    };
}

// Logger Root

function LoggerRoot() {
    this.seqNum = 1;

    this.signals = Object.assign(this.signals || {}, {
        onRawLog: new Signal(),
        onLineLog: new Signal(),
        onFormattedLog: new Signal(),
        onFlush: new Signal(),
        onError: new Signal()
    });
}

LoggerRoot.prototype = Object.create(Logger.prototype, {
    constructor: {
        value: LoggerRoot
    }
});

LoggerRoot.prototype.flush = function flush() {
    this.signals.onFlush.dispatch();
};

module.exports = {
    pluginName: 'logger',

    dependencies: [
        'nodeName',
        'context'
    ],

    nodeMethods: Logger.prototype,
    getNodeMethodOverrides: getLoggerMethodOverrides,

    rootInit: LoggerRoot,
    rootMethods: LoggerRoot.prototype
};



//////////////////
// WEBPACK FOOTER
// ./~/@getgo/logger/plugins/logger.js
// module id = 719
// module chunks = 0